import { useState } from 'react'
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { PropTypes } from 'prop-types'
import { useRequest } from 'hooks/useRequest'
import { updateEdittedRow } from 'redux/features/projectDetail/projectDetailSlice'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import useToast from 'hooks/useToast'
import { currencyTypes, responsibleRoles } from 'utils/Constants';
import { Dialog } from 'primereact/dialog';
import InvoiceApprovalModalContent from 'components/modalContent/InvoiceApprovalModalContent';

const EditInvoiceModalContent = (props) => {
    // const [request, requestLoading] = useRequest()
    const [uploadFile] = useRequest()
    const { showToast } = useToast()
    const { projectDetail } = useSelector((state) => state)
    const [invoiceApprovalModal, setInvoiceApprovalModal] = useState({ open: false, text: '', setter: null, invoiceStatusId: null })
    const { invoiceStatuses, edittedRow } = projectDetail
    const dispatch = useDispatch()
    const [formData, setFormData] = useState(props.editInvoiceModal.formData)
    const handleCloseApprovalModal = () => {
        setInvoiceApprovalModal({ open: false, text: '', setter: null, invoiceStatusId: null })
        setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
    }
    const handleApproved = () => {
        if (invoiceApprovalModal.invoiceStatusId == 1) {
            setFormData(prev => ({ ...prev, actualDate: moment().add(3, 'hours').toISOString(), invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
            handleCloseApprovalModal()
        }
        if (invoiceApprovalModal.invoiceStatusId == 2) {
			if (!formData.estimatedDate) {
				showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
			}else {
				setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
				handleCloseApprovalModal()
			}
		}
		if (invoiceApprovalModal.invoiceStatusId == 7) {
			if (!formData.description || !formData.invoiceNo) {
                showToast('Fatura Numarası ve Açıklama giriniz','error')
            } else {
            setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
            handleCloseApprovalModal()
            }
		}
    }
    const validateSelectedFile = (file) => {
		const MAX_FILE_SIZE = 20480 // 20MB
		const fileSizeKiloBytes = file.size / 1024
		let errorMsg = ''
		if (fileSizeKiloBytes > MAX_FILE_SIZE) {
			errorMsg = "Dosya 20mb'dan küçük olmalıdır ";
		}
		return errorMsg
	};
    const convert = async (fileList) => {
        let errorMessage = ''
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            if (validateSelectedFile(file) != '') {
                errorMessage = validateSelectedFile(file)
                break
            }
        }
        if (errorMessage == '') {
            for await (const file of fileList) {
                const formDatas = new FormData();
                formDatas.append("File", file);
                formDatas.append('InvoiceId', formData.id)
                uploadFile('/Invoices/AddInvoiceDocuments', {
                    method: 'POST',
                    data: formDatas
                }).then(res => {
                    if (res.data.ok) {
                        setFormData(prev => ({...prev,invoicesDocuments:prev.invoicesDocuments == null ? [{...res.data.result}] : [...prev.invoicesDocuments,{...res.data.result}]}))
                        dispatch(updateEdittedRow({key:'invoices',value: edittedRow.invoices.map(invoice => {
                            if (invoice.id == formData.id) {
                                return {...formData, invoicesDocuments:formData.invoicesDocuments == null ? [{...res.data.result}] : [...formData.invoicesDocuments,{...res.data.result}]}
                            } else {
                                return invoice
                            }
                        })}))
                    } else {
                        showToast(res.data.metadata.message, 'error')
                    }
                })
            }
        } else {
            showToast(errorMessage, 'error')
        }
    };
    const handleChange = (value, name) => {
        if (name == 'files') {
            console.log(value)
            convert(value)
            
        } else if (name == 'percent' && edittedRow?.budget) {
            const amountData = Number(edittedRow?.budget) / 100 * Number(value)
            setFormData((prev) => ({ ...prev, [name]: value, amount: amountData.toFixed(0) }))
        } else if (name == 'invoiceStatusId') {
            if (value == 1) {
                setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Ödeme tarihini bugün olarak güncellemek ister misiniz?' })
            } else if (value == 2) {
                setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Ödeme Onayı Belgesi' })
            } else if (value == 7) {
                setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Fatura No ve Ödeme Onayı Belgesi' })
            } else {
                setFormData((prev) => ({ ...prev, [name]: value }))
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }))
        }
    }
    const removeFile = (file) => {
        uploadFile('/Invoices/DeleteInvoiceDocuments', {
            method:'DELETE',
            data:file
        }).then(res => {
            if (res.data.ok) {
                setFormData(prev => ({...prev,invoicesDocuments:[...prev.invoicesDocuments.filter(f => f.id != file.id)]}))
                dispatch(updateEdittedRow({key:'invoices',value: edittedRow.invoices.map(invoice => {
                    if (invoice.id == formData.id) {
                        return {...invoice, invoicesDocuments:invoice.invoicesDocuments.filter(f => f.id != file.id)}
                    } else {
                        return invoice
                    }
                })}))
            } else {
                showToast('Silme İşlemi Sırasında Bir Hata Oluştu', 'error')
            }
        })
    }

    // const closeDialogFunc = () => {
    //     props.onHide()
    // }
    // const addBillFunc = () => {
    //     if (!edittedRow?.budget) {
    //         showToast('Fatura kalemi eklemek için lütfen bütçeyi giriniz.', 'error')
    //     } else if (!formData.name) {
    //         showToast('Proje Adımı Giriniz', 'error')
    //     } else if (!formData.responsibleRole) {
    //         showToast('Sorumlu Kişiyi Seçiniz', 'error')
    //     }else if (formData.invoiceStatusId == 2 && !formData.estimatedDate) {
	// 		showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
	// 	} else {
    //         request('/Invoices/UpdateInvoices', {
    //             method: 'PUT',
    //             data: {...formData,amount:formData.amount.toString()},
    //         }).then((res) => {
    //             if (res.data.ok) {
    //                 dispatch(updateEdittedRow({key:'invoices',value: edittedRow.invoices.map(invoice => {
    //                     if (invoice.id == formData.id) {
    //                         return {...formData, status:invoiceStatuses.map(s => ({name:s.label, id:s.value})).find(s => s.id == formData.invoiceStatusId)}
    //                     } else {
    //                         return invoice
    //                     }
    //                 })}))
    //                 closeDialogFunc()
    //             } else {
    //                 showToast('Bir Sorun Oluştu', 'error')
    //             }
    //         })
    //     }

    // }

    return (
        <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
            <Dialog draggable={false} visible={invoiceApprovalModal.open} onHide={handleCloseApprovalModal}>
                <InvoiceApprovalModalContent filesData={formData.invoicesDocuments} formData={formData} removeFile={removeFile} handleChange={handleChange} handleClose={handleCloseApprovalModal} approvalModal={invoiceApprovalModal} handleApproved={handleApproved} />
            </Dialog>
            <div className="row">
                <div className='col-md-12'>
                    <div className='form-control'>
                        <label htmlFor="">Fatura Adımı</label>
                        <input className='default-input' disabled={!props.editInvoiceModal.isEditable} placeholder='Fatura Adımı' value={formData.name} name='name' type='text' onChange={(e) => handleChange(e.target.value, 'name')} />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <label htmlFor="">Sorumlu Kişi</label>
                        <Dropdown disabled={!props.editInvoiceModal.isEditable} placeholder='Sorumlu Kişi' value={formData.responsibleRole && formData.responsibleRole} options={responsibleRoles} onChange={(e) => handleChange(e.value, 'responsibleRole')} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-control">
                    <label htmlFor="">Fatura Durumu</label>
                    <Dropdown
                        disabled={!props.editInvoiceModal.isEditable || (formData?.invoiceStatusId == 1 || formData?.invoiceStatusId == 7)}
                        optionLabel='label'
                        optionValue='value'
                        placeholder='Fatura Durumu'
                        value={formData?.invoiceStatusId && formData.invoiceStatusId}
                        options={formData.status.name.includes('Ödendi') ? invoiceStatuses?.filter(s => (!s.label.includes('Kesildi'))) : formData.status.name.includes('Kesildi') ? invoiceStatuses?.filter(s => (!s.label.includes('Ödendi'))) : invoiceStatuses?.filter(s => (!s.label.includes('Ödendi') && !s.label.includes('Kesildi')))}
                        onChange={(e) => { handleChange(e.value, 'invoiceStatusId') }}
                    />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <label htmlFor="">Kesilecek Ay</label>
                        <Calendar
                            view="month" 
							dateFormat="mm/yy"
                            placeholder='Kesilecek Ay'
                            disabled={!props.editInvoiceModal.isEditable}
                            value={formData?.estimatedDate && moment(formData?.estimatedDate).locale('en')._d}
                            name='estimatedDate'
                            onChange={(e) => {
                                handleChange(moment(e.target.value).add(3, 'hours').toISOString(), 'estimatedDate')
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <label htmlFor="">Ödeme Yüzdesi</label>
                        <InputNumber placeholder='Ödeme Yüzdesi' disabled={!props.editInvoiceModal.isEditable} max={100} value={formData?.percent} mode="decimal" onBlur={e => handleChange(e.target.value, 'percent')} name='percent' onChange={(e) => handleChange(e.value, 'percent')} />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <label htmlFor="">Tutar</label>
                        <InputNumber mode="decimal" disabled={!props.editInvoiceModal.isEditable} minFractionDigits={2} placeholder='Tutar' name='amount' value={formData.amount} onChange={(e) => handleChange(e.value, 'amount')} />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <label htmlFor="">Para Birimi</label>
                        <Dropdown placeholder='Para Birimi' disabled={!props.editInvoiceModal.isEditable} value={formData?.currency && formData.currency} optionLabel='label' optionValue='value' options={currencyTypes} onChange={(e) => handleChange(e.value, 'currency')} />
                    </div>
                </div>
            </div>
            {/* <div className='row justify-content-center'>
                <div className='col-md-3'>
                    <Button handleClick={addBillFunc} disabled={requestLoading || !props.editInvoiceModal.isEditable} className='btn-success w-100 justify-content-center' title={'Güncelle'} />
                </div>
                <div className='col-md-3'>
                    <Button
                        handleClick={() => closeDialogFunc()}
                        className='btn-danger-outline w-100 justify-content-center'
                        title={'Vazgeç'}
                    />
                </div>
            </div> */}
        </div>
    )
}
EditInvoiceModalContent.propTypes = {
    onHide: PropTypes.func
};
export default EditInvoiceModalContent
